module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjM1NiIgaGVpZ2h0PSIxMS4xMTYiIHZpZXdCb3g9IjAgMCA2LjM1NiAxMS4xMTYiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiMxMDcwY2E7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTUuNjg2LDExLjc1MmwtNC4yMDctNC4yYS43OTEuNzkxLDAsMCwxLDAtMS4xMjIuOC44LDAsMCwxLDEuMTI1LDBsNC43NjYsNC43NjNhLjc5My43OTMsMCwwLDEsLjAyMywxLjFsLTQuNzg2LDQuOGEuNzk1Ljc5NSwwLDEsMS0xLjEyNS0xLjEyMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMS4yNDYgLTYuMTk2KSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/ionic-ios-arrow-forward.svg
// module id = 227
// module chunks = 1